import {
  CMSBlock,
  HelperArticle,
  User,
} from "@tudigo-monorepo/core-tudigo-api-models";
import { CollectionRequestParams } from "@tudigo-monorepo/web-tudigo-api-client";

import { ContentType, Request, RequestParams, TudigoResponse } from "../api";

export type GetHelperArticlesFilters = object | undefined; // TODO: add filters

export type GetHelperArticlesQueryParams = CollectionRequestParams<
  undefined,
  GetHelperArticlesFilters
>;

export type CreateHelperArticleBody = {
  name: string;
  description: string;
  content: CMSBlock[];
  status: string | null;
  user: User;
};

export const helperArticlesEndPoints = (request: Request) => ({
  createHelperArticle: (
    body: CreateHelperArticleBody,
    queryParams: GetHelperArticlesQueryParams = {},
    params: RequestParams = {},
  ) =>
    request<TudigoResponse<HelperArticle>, void>({
      path: "/api/v1/helper-articles",
      method: "POST",
      query: {
        fields: queryParams?.fields,
        ...queryParams?.filters,
        ...queryParams?.pagination,
        ...queryParams?.sorting,
      },
      body,
      secure: true,
      type: ContentType.Json,
      ...params,
    }),

  createHelperArticleFeedback: (
    helperArticleId: HelperArticle["id"],
    body?: { [key: string]: unknown },
  ) =>
    request<TudigoResponse<HelperArticle>, void>({
      path: `/api/v1/helper-articles/${helperArticleId}/helper-article-feedbacks`,
      method: "POST",
      body,
      secure: true,
      type: ContentType.Json,
    }),

  getHelperArticleById: (
    helperArticleId: HelperArticle["id"],
    query?: { [key: string]: unknown },
  ) =>
    request<TudigoResponse<HelperArticle>, void>({
      path: `/api/v1/helper-articles/${helperArticleId}`,
      method: "GET",
      query,
      secure: true,
      type: ContentType.Json,
    }),

  getHelperArticles: (queryParams?: GetHelperArticlesQueryParams) =>
    request<TudigoResponse<HelperArticle[]>, void>({
      path: "/api/v1/helper-articles",
      method: "GET",
      query: {
        fields: queryParams?.fields,
        ...queryParams?.filters,
        ...queryParams?.pagination,
        ...queryParams?.sorting,
      },
      secure: true,
      type: ContentType.Json,
    }),

  updateHelperArticle: (
    helperArticleId: HelperArticle["id"],
    body: HelperArticle,
    query?: {
      fields?: string;
    },
    params: RequestParams = {},
  ) =>
    request<TudigoResponse<HelperArticle>, void>({
      path: `/api/v1/helper-articles/${helperArticleId}`,
      method: "PUT",
      body: body,
      query: query,
      secure: true,
      type: ContentType.Json,
      ...params,
    }),

  deleteHelperArticle: (helperArticleId: HelperArticle["id"]) =>
    request<TudigoResponse<HelperArticle>, void>({
      path: `/api/v1/helper-articles/${helperArticleId}`,
      method: "DELETE",
      secure: true,
    }),
});
